import { Box } from '@chakra-ui/layout'
import { Button, ButtonGroup } from '@chakra-ui/react'
import { useMemo } from 'react'

export function Pagination({
  handlePrevPage,
  handleNextPage,
  handlePageClick,
  pagination,
}) {
  const currentPage = pagination?.current_page

  const distanceCurrentPageToLastPage = useMemo(() => {
    return pagination?.last_page - currentPage
  }, [currentPage, pagination])

  const showLastPage = useMemo(() => {
    return pagination?.last_page > 5
  }, [pagination])

  return (
    <Box>
      <ButtonGroup spacing="2">
        <Button
          onClick={handlePrevPage}
          variant="outline"
          colorScheme="blue"
          size="sm"
        >
          Anterior
        </Button>

        <Button size="sm" colorScheme="blue">
          {currentPage}
        </Button>

        <Button
          onClick={() => handlePageClick(currentPage + 1)}
          variant="outline"
          colorScheme="blue"
          size="sm"
        >
          {currentPage + 1}
        </Button>

        {showLastPage && (
          <>
            <Button
              onClick={() => handlePageClick(pagination?.last_page)}
              variant="outline"
              colorScheme="blue"
              size="sm"
            >
              ...
            </Button>

            <Button
              onClick={() => handlePageClick(pagination?.last_page - 1)}
              variant="outline"
              colorScheme="blue"
              size="sm"
            >
              {pagination?.last_page - 1}
            </Button>

            <Button
              onClick={() => handlePageClick(pagination?.last_page)}
              variant="outline"
              colorScheme="blue"
              size="sm"
            >
              {pagination?.last_page}
            </Button>
          </>
        )}

        <Button
          size="sm"
          onClick={handleNextPage}
          variant="outline"
          colorScheme="blue"
        >
          Próxima
        </Button>
      </ButtonGroup>
    </Box>
  )
}
